/**
 * Manager module UI labels
 * These are default labels that can be overridden per company
 */
export const MANAGER_LABELS = {
  manager: "Manager",
  managers: "Managers",
  addManager: "Add Manager",
  addManagers: "Add Managers",
  createManager: "Create Manager",
  editManager: "Edit Manager",
  managerDetails: "Manager Details",
  workManagers: "Work Managers",
  // Manager Modal Form labels
  firstName: "First name",
  lastName: "Last name",
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  emailRequired: "Email is required",
  invalidEmailAddress: "Invalid email address",
  passwordRequired: "Password is required",
  leaveBlankIfDontWantToChangePassword: "Leave blank if you don't want to change the password",
  passwordRequirement: "The password must have at least 8 characters, 1 digit, 1 upper case letter",
  deleteManagerQuestion: "Delete '{name}' ?",
  dataRestored: "Data restored",
  nA: "N/A",
} as const;

export type ManagerLabelKey = keyof typeof MANAGER_LABELS;
